<soillib-nav-header id="header"></soillib-nav-header>

<soillib-loader></soillib-loader>

<div id="container">
  <router-outlet></router-outlet>
</div>
